import CustomQuestion from '@public/icons/question_new.svg';
import React, { SVGProps } from 'react';

type CustomQuestionWrapperProps = SVGProps<SVGSVGElement>;
const CustomQuestionWrapper: React.FC<CustomQuestionWrapperProps> = (props) => {
  return <CustomQuestion {...props} />;
};

export default CustomQuestionWrapper;
